import React, { Component } from 'react';
import firebase from './../Firestore'
//import { Link } from 'react-router-dom';


//import config from 'react-global-configuration';

class VerificarCliente extends Component {

  constructor(props) {
    super(props);

    this.unsubscribe = null;

    this.state = {
      cantCompras: undefined
    };
  }

  async componentDidMount() {
      const ref = firebase.firestore().collection("pedido").where("clienteTelefono", "==", this.props.telefono).where("estado", "==", "entregado");

      this.unsubscribe = await ref.onSnapshot(this.onCollectionUpdate);
  }

  onCollectionUpdate = (querySnapshot) => {
    //console.log("cant compras", querySnapshot.size)
      this.setState({
      cantCompras: querySnapshot.size
   });
  }


  render() {

  //  if(!this.state.cantCompras) return null

    return (
      <span className="d-print-none d-block">

      {this.state.cantCompras > 0 ? (
        <span className="badge badge-primary">Verificado con {this.state.cantCompras} {this.state.cantCompras === 1? "pedido anterior": "pedidos anteriores"}</span>
      ) : (
        <span className="badge badge-danger">No verificado</span>
      )}

    </span>

    );
  }
}

export default VerificarCliente;
